import React from 'react';

import {
    CustomInputLabelWrapper,
    CustomInputLabel,
    LabelText,
    CustomInput,
    LabelIcon,
} from './styled';

interface Props {
    placeholder?: string;
    name: string;
    onChange: (x?: any) => void;
    labelText?: string;
    noMargin?: boolean;
}
export const InputLabel = ({noMargin, placeholder, name, labelText, onChange}: Props) => (
    <CustomInputLabelWrapper>
        {labelText ? <LabelText>{labelText}</LabelText> : ''}
        <CustomInputLabel noMargin={noMargin}>
            <CustomInput
                type="text"
                placeholder={placeholder ?? ''}
                name={name}
                onChange={onChange}
            />
            <LabelIcon />
        </CustomInputLabel>
    </CustomInputLabelWrapper>
);
